module.exports = __webpack_public_path__ + "static/media/metrioptera_brachyptera_BD_004_APA.5b4a2dab.png";